import { action } from 'easy-peasy';
import { IActionSetCurrent } from '../types';

const setCurrent: IActionSetCurrent = action((state, payload) => {
  state.current = payload;
});

export default setCurrent;
